import { AsyncPipe } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import {
  ControlValueAccessor,
  FormsModule,
  NgControl,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatChipsModule } from '@angular/material/chips';
import { ErrorStateMatcher, MatCommonModule } from '@angular/material/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { SelectOptionModel } from '../models/select-option.model';
import { ErrorMessagesPipe } from '../pipes/error-messages.pipe';
import { DefaultErrorStateMatcher } from '../validation/DefaultErrorStateMatcher';

@Component({
    selector: 'cerrix-select',
    imports: [
    ErrorMessagesPipe,
    FormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatChipsModule,
    MatIconModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    AsyncPipe,
    MatCommonModule,
    MatDividerModule
],
    templateUrl: './cerrix-select.component.html',
    styleUrl: './cerrix-select.component.scss',
    providers: []
})
export class CerrixSelectComponent implements ControlValueAccessor {
  @Input() public placeholder: string = '';
  @Input() public disabled: boolean = false;
  @Input() public type: 'primary' | 'success' = 'primary';
  @Input() public showNone: boolean = true;
  @Input() public useVisibility: boolean = false;
  @Input() public dataUiid: string = "undefined"

  private _options: SelectOptionModel[] = [];
  @Input()
  set options(value: SelectOptionModel[]) {
    if (this._options === value) {
      return;
    }

    this._options = value;
    this.setSelection();

    this.hasColorBadge = this.options.some(o => !!o.color);
  }
  get options() {
    return this._options;
  }

  private _selected: string | undefined;
  @Input()
  set selected(value: string | undefined) {
    if (this._selected === value) {
      return;
    }

    this._selected = value;
    this.setSelection();
  }
  get selected() {
    return this._selected;
  }

  protected hasColorBadge: boolean = false;
  protected errorMatcher!: ErrorStateMatcher;
  protected ngControl = inject(NgControl, { optional: true, self: true });
  protected selectedOption: SelectOptionModel | undefined;

  private onValueChange = (value: string) => {};
  private onTouched = () => {};

  public writeValue(value: string): void {
    this.selected = value;
  }
  public registerOnChange(onChange: (value: string) => void): void {
    this.onValueChange = onChange;
  }
  public registerOnTouched(onTouched: () => void): void {
    this.onTouched = onTouched;
  }
  public setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  constructor() {
    if (this.ngControl != null) {
      this.ngControl.valueAccessor = this;
      this.errorMatcher = new DefaultErrorStateMatcher();
    }
  }

  protected onselectionChanged(event: MatSelectChange) {
    this.selected = event.value;
    this.onValueChange(event.value);
  }

  private setSelection() {
    if (this.options) {
      this.selectedOption = this.options.find(o => o.id === this.selected);
    }
  }
}
